module.exports = __webpack_public_path__ + "img/18.d7bc2621.jpg";